window.iconsOriginal = [
  {
    name: "none",
    uni: "E000",
    dec: "57344",
    tags: "clear, empty, blank"
  },
  {
    name: "pencil",
    uni: "E001",
    dec: "57345",
    tags: "edit, create"
  },
  {
    name: "brush",
    uni: "E002",
    dec: "57346",
    tags: "create, art, paint"
  },
  {
    name: "wifi",
    uni: "E004",
    dec: "57348",
    tags: "wireless, router"
  },
  {
    name: "chat",
    uni: "E005",
    dec: "57349",
    tags: "sms, message"
  },
  {
    name: "notifications",
    uni: "E007",
    dec: "57351",
    tags: "alert"
  },
  {
    name: "notifications_off",
    uni: "E008",
    dec: "57352",
    tags: "alert, bell, alarm"
  },
  {
    name: "notifications_active",
    uni: "E009",
    dec: "57353",
    tags: "alert, bell, alarm"
  },
  {
    name: "send",
    uni: "E00A",
    dec: "57354",
    tags: "sent"
  },
  {
    name: "person",
    uni: "E00B",
    dec: "57355",
    tags: "user, account"
  },
  {
    name: "people",
    uni: "E00C",
    dec: "57356",
    tags: "group"
  },
  {
    name: "no_show",
    uni: "E00D",
    dec: "57357",
    tags: "person, hide, account, user"
  },
  {
    name: "person_status",
    uni: "E00E",
    dec: "57358",
    tags: "account, user, person"
  },
  {
    name: "chart",
    uni: "E013",
    dec: "57363",
    tags: "poll, analytics, bar"
  },
  {
    name: "restore",
    uni: "E01F",
    dec: "57375",
    tags: "reset, refresh, back, undo"
  },
  {
    name: "undo",
    uni: "E02A",
    dec: "57386",
    tags: "reset, refresh, back, restore"
  },
  {
    name: "update",
    uni: "E02B",
    dec: "57387",
    tags: "reset, refresh"
  },
  {
    name: "refresh",
    uni: "E02C",
    dec: "57388",
    tags: "reset, refresh, update"
  },
  {
    name: "chevron_up",
    uni: "E02D",
    dec: "57389",
    tags: "arrow, expand, keyboard, caret, navigate"
  },
  {
    name: "chevron_right",
    uni: "E02E",
    dec: "57390",
    tags: "arrow, forward, keyboard, navigate, caret, navigate"
  },
  {
    name: "chevron_down",
    uni: "E02F",
    dec: "57391",
    tags: "arrow, expand, keyboard, caret, navigate"
  },
  {
    name: "chevron_left",
    uni: "E03A",
    dec: "57402",
    tags: "arrow, back, keyboard, navigate, caret, navigate"
  },
  {
    name: "arrow_up",
    uni: "E03B",
    dec: "57403",
    tags: "chevron, keyboard, navigate"
  },
  {
    name: "arrow_right",
    uni: "E03C",
    dec: "57404",
    tags: "chevron, forward, keyboard, navigate"
  },
  {
    name: "arrow_down",
    uni: "E03D",
    dec: "57405",
    tags: "chevron, keyboard, navigate"
  },
  {
    name: "arrow_left",
    uni: "E03E",
    dec: "57406",
    tags: "chevron, back, keyboard, navigate"
  },
  {
    name: "delete",
    uni: "E03F",
    dec: "57407",
    tags: "remove"
  },
  {
    name: "volume",
    uni: "E04C",
    dec: "57420",
    tags: "sound, speaker, audio"
  },
  {
    name: "volume_low",
    uni: "E04D",
    dec: "57421",
    tags: "sound, speaker, audio"
  },
  {
    name: "volume_medium",
    uni: "E04E",
    dec: "57422",
    tags: "sound, speaker, audio"
  },
  {
    name: "volume_up",
    uni: "E04F",
    dec: "57423",
    tags: "sound, speaker, audio"
  },
  {
    name: "volume_off",
    uni: "E05A",
    dec: "57434",
    tags: "sound, speaker, mute"
  },
  {
    name: "hearing",
    uni: "E05B",
    dec: "57435",
    tags: "sound, listening, audio"
  },
  {
    name: "mic",
    uni: "E05C",
    dec: "57436",
    tags: "voice, record, audio"
  },
  {
    name: "mic_off",
    uni: "E05D",
    dec: "57437",
    tags: "voice, record, audio"
  },
  {
    name: "recording",
    uni: "E05E",
    dec: "57438",
    tags: "voice, record, audio"
  },
  {
    name: "no_audio",
    uni: "E05F",
    dec: "57439",
    tags: "sound, speaker, mute"
  },
  {
    name: "refresh_audio",
    uni: "E06A",
    dec: "57450",
    tags: "sound, speaker, volume, refresh, load"
  },
  {
    name: "load_audio",
    uni: "E06B",
    dec: "57451",
    tags: "sound, speaker, volume"
  },
  {
    name: "play_arrow",
    uni: "E06D",
    dec: "57453",
    tags: "record, audio, player"
  },
  {
    name: "pause",
    uni: "E06E",
    dec: "57454",
    tags: "audio, player, stop"
  },
  {
    name: "stop",
    uni: "E06F",
    dec: "57455",
    tags: "audio, player"
  },
  {
    name: "skip_next",
    uni: "E07A",
    dec: "57466",
    tags: "audio, player, forward"
  },
  {
    name: "skip_previous",
    uni: "E07B",
    dec: "57467",
    tags: "audio, player, backward"
  },
  {
    name: "record",
    uni: "E07C",
    dec: "57468",
    tags: "audio, player, play"
  },
  {
    name: "previous",
    uni: "E08C",
    dec: "57484",
    tags: "arrow, caret, chevron, skip, navigate"
  },
  {
    name: "next",
    uni: "E08D",
    dec: "57485",
    tags: "arrow, caret, chevron, skip, navigate"
  },
  {
    name: "cloud",
    uni: "E097",
    dec: "57495",
    tags: "weather"
  },
  {
    name: "upload",
    uni: "E098",
    dec: "57496",
    tags: "arrow, up, cloud, up"
  },
  {
    name: "up_balls",
    uni: "E099",
    dec: "57497",
    tags: "arrow, up, "
  },
  {
    name: "download",
    uni: "E09A",
    dec: "57498",
    tags: "arrow, down, bottom"
  },
  {
    name: "rearrange",
    uni: "E09B",
    dec: "57499",
    tags: "arrow, reorder, sort"
  },
  {
    name: "slider",
    uni: "E09D",
    dec: "57501",
    tags: "sort, filter, setting"
  },
  {
    name: "list",
    uni: "E09E",
    dec: "57502",
    tags: "menu"
  },
  {
    name: "sidebar_close",
    uni: "E09F",
    dec: "57503",
    tags: "menu"
  },
  {
    name: "sidebar_open",
    uni: "E0A0",
    dec: "57504",
    tags: "menu"
  },
  {
    name: "open_menu",
    uni: "E0A1",
    dec: "57505",
    tags: "text, menu"
  },
  {
    name: "close_menu",
    uni: "E0A2",
    dec: "57506",
    tags: "text, menu"
  },
  {
    name: "down_menu",
    uni: "E0A3",
    dec: "57507",
    tags: "text, menu"
  },
  {
    name: "up_menu",
    uni: "E0A4",
    dec: "57508",
    tags: "text, menu"
  },
  {
    name: "launch",
    uni: "E0A5",
    dec: "57509",
    tags: "exit, open, dialog, modal"
  },
  {
    name: "exit_to_app",
    uni: "E0A6",
    dec: "57510",
    tags: ""
  },
  {
    name: "menu",
    uni: "E0A7",
    dec: "57511",
    tags: "hamburger"
  },
  {
    name: "more_vert",
    uni: "E0A8",
    dec: "57512",
    tags: "menu"
  },
  {
    name: "more_horiz",
    uni: "E0A9",
    dec: "57513",
    tags: "menu"
  },
  {
    name: "cell_phone",
    uni: "E0B8",
    dec: "57528",
    tags: "mobile, telephone, smart"
  },
  {
    name: "phone",
    uni: "E0B9",
    dec: "57529",
    tags: "telephone"
  },
  {
    name: "home",
    uni: "E0BA",
    dec: "57530",
    tags: "house"
  },
  {
    name: "language",
    uni: "E0BB",
    dec: "57531",
    tags: "globe, translate"
  },
  {
    name: "url",
    uni: "E0BC",
    dec: "57532",
    tags: "link"
  },
  {
    name: "lang",
    uni: "E0BD",
    dec: "57533",
    tags: "language, translate"
  },
  {
    name: "lang_help",
    uni: "E0BE",
    dec: "57534",
    tags: "language, translate, help, support, aid"
  },
  {
    name: "map",
    uni: "E0BF",
    dec: "57535",
    tags: "place, location, pin"
  },
  {
    name: "country",
    uni: "E0C0",
    dec: "57536",
    tags: "place, location, flag, globe, gps"
  },
  {
    name: "navigation",
    uni: "E0C1",
    dec: "57537",
    tags: "place, location, compass, gps"
  },
  {
    name: "notification",
    uni: "E0C8",
    dec: "57544",
    tags: "push, mobile, phone"
  },
  {
    name: "flag",
    uni: "E0C9",
    dec: "57545",
    tags: "report"
  },
  {
    name: "place",
    uni: "E0CA",
    dec: "57546",
    tags: "location, pin, map"
  },
  {
    name: "mail",
    uni: "E0CB",
    dec: "57547",
    tags: "email, envelope"
  },
  {
    name: "award",
    uni: "E0E7",
    dec: "57575",
    tags: "prize, discount"
  },
  {
    name: "trophy",
    uni: "E0E8",
    dec: "57576",
    tags: "prize, award"
  },
  {
    name: "shopping_cart",
    uni: "E0F5",
    dec: "57589",
    tags: "checkout"
  },
  {
    name: "bet",
    uni: "E0F6",
    dec: "57590",
    tags: "credit, card, debit, money, cash, casino, game"
  },
  {
    name: "add_balance",
    uni: "E0F7",
    dec: "57591",
    tags: "credit, card, debit, money, cash"
  },
  {
    name: "payment",
    uni: "E0F8",
    dec: "57592",
    tags: "credit, card, debit, money, cash"
  },
  {
    name: "bill",
    uni: "E0F9",
    dec: "57593",
    tags: "credit, card, debit, money, cash"
  },
  {
    name: "deal",
    uni: "E0FA",
    dec: "57594",
    tags: "prize, redeem, promo, discount"
  },
  {
    name: "gift",
    uni: "E0FB",
    dec: "57595",
    tags: "prize, redeem, promo, discount"
  },
  {
    name: "time",
    uni: "E0FC",
    dec: "57596",
    tags: "clock, schedule, watch"
  },
  {
    name: "chronometer",
    uni: "E0FD",
    dec: "57597",
    tags: "clock, schedule, watch, stopwatch"
  },
  {
    name: "time_record",
    uni: "E0FE",
    dec: "57598",
    tags: "chronometer, clock, schedule, watch, stopwatch"
  },
  {
    name: "folder",
    uni: "E111",
    dec: "57617",
    tags: "doc, file"
  },
  {
    name: "folder_open",
    uni: "E112",
    dec: "57618",
    tags: "doc, file"
  },
  {
    name: "folder_add",
    uni: "E113",
    dec: "57619",
    tags: "doc, file"
  },
  {
    name: "folder_special",
    uni: "E114",
    dec: "57620",
    tags: "doc, file"
  },
  {
    name: "folder_delete",
    uni: "E115",
    dec: "57621",
    tags: "doc, file"
  },
  {
    name: "page",
    uni: "E117",
    dec: "57623",
    tags: "doc, file"
  },
  {
    name: "book",
    uni: "E118",
    dec: "57624",
    tags: "study, docs, menu"
  },
  {
    name: "test",
    uni: "E119",
    dec: "57625",
    tags: "study, exam, quiz"
  },
  {
    name: "flash_cards",
    uni: "E11A",
    dec: "57626",
    tags: "flip"
  },
  {
    name: "pdf",
    uni: "E124",
    dec: "57636",
    tags: "page, doc, file"
  },
  {
    name: "doc",
    uni: "E125",
    dec: "57637",
    tags: "page, doc, file"
  },
  {
    name: "jpg",
    uni: "E126",
    dec: "57638",
    tags: "page, doc, file, image"
  },
  {
    name: "png",
    uni: "E127",
    dec: "57639",
    tags: "page, doc, file, image"
  },
  {
    name: "chevron_tr",
    uni: "E130",
    dec: "57648",
    tags: "arrow, expand, keyboard, caret"
  },
  {
    name: "chevron_dr",
    uni: "E131",
    dec: "57649",
    tags: "arrow, expand, keyboard, caret"
  },
  {
    name: "chevron_dl",
    uni: "E132",
    dec: "57650",
    tags: "arrow, expand, keyboard, caret"
  },
  {
    name: "chevron_tl",
    uni: "E133",
    dec: "57651",
    tags: "arrow, expand, keyboard, caret"
  },
  {
    name: "check",
    uni: "E134",
    dec: "57652",
    tags: "mark"
  },
  {
    name: "check_outline",
    uni: "E135",
    dec: "57653",
    tags: "mark"
  },
  {
    name: "checked",
    uni: "E136",
    dec: "57654",
    tags: "square, mark, box"
  },
  {
    name: "unchecked",
    uni: "E137",
    dec: "57655",
    tags: "square, mark, check, box"
  },
  {
    name: "rb_checked",
    uni: "E139",
    dec: "57657",
    tags: "circle, mark, radio, button"
  },
  {
    name: "rb_unchecked",
    uni: "E13A",
    dec: "57658",
    tags: "circle, mark, radio, button"
  },
  {
    name: "match",
    uni: "E13B",
    dec: "57659",
    tags: "correspond, align, fit, check"
  },
  {
    name: "temperature",
    uni: "E163",
    dec: "57699",
    tags: "thermometer, hot, warm, cold, heat"
  },
  {
    name: "odd_even",
    uni: "E164",
    dec: "57700",
    tags: "fire, warm"
  },
  {
    name: "hot",
    uni: "E165",
    dec: "57701",
    tags: "fire, warm"
  },
  {
    name: "cold",
    uni: "E166",
    dec: "57702",
    tags: "ice, cold, frozen"
  },
  {
    name: "hot_cold",
    uni: "E167",
    dec: "57703",
    tags: "fire, warm, fire, warm"
  },
  {
    name: "delta",
    uni: "E168",
    dec: "57704",
    tags: "sign"
  },
  {
    name: "delta_cold",
    uni: "E169",
    dec: "57705",
    tags: "sign, ice, cold, frozen"
  },
  {
    name: "delta_hot",
    uni: "E16A",
    dec: "57706",
    tags: "sign, fire, warm"
  },
  {
    name: "sum",
    uni: "E16B",
    dec: "57707",
    tags: "plus, add"
  },
  {
    name: "sum_hot",
    uni: "E16C",
    dec: "57708",
    tags: "plus, add, fire, warm"
  },
  {
    name: "sum_cold",
    uni: "E16D",
    dec: "57709",
    tags: "plus, add, ice, cold, frozen"
  },
  {
    name: "face_id",
    uni: "E177",
    dec: "57719",
    tags: "fingerprint, identity, passcode"
  },
  {
    name: "scan",
    uni: "E17F",
    dec: "57727",
    tags: "barcode, qr"
  },
  {
    name: "retry_scan",
    uni: "E180",
    dec: "57728",
    tags: "barcode, qr"
  },
  {
    name: "ar_horiz",
    uni: "E181",
    dec: "57729",
    tags: "aspect, ratio"
  },
  {
    name: "ar_vert",
    uni: "E182",
    dec: "57730",
    tags: "aspect, ratio"
  },
  {
    name: "parking",
    uni: "E19F",
    dec: "57759",
    tags: "car, spot"
  },
  {
    name: "bike",
    uni: "E1A0",
    dec: "57760",
    tags: "parking, pedal"
  },
  {
    name: "walk",
    uni: "E1A1",
    dec: "57761",
    tags: "direction"
  },
  {
    name: "girl",
    uni: "E1A2",
    dec: "57762",
    tags: "child, boy, girl, kid"
  },
  {
    name: "boy",
    uni: "E1A3",
    dec: "57763",
    tags: "child, boy, girl, kid"
  },
  {
    name: "disabled",
    uni: "E1A4",
    dec: "57764",
    tags: "incapable, helpless, handicapped, invalid, kept, hind"
  },
  {
    name: "photo_id",
    uni: "E1A5",
    dec: "57765",
    tags: "id, badge, passport"
  },
  {
    name: "politician",
    uni: "E1CC",
    dec: "57804",
    tags: "speech, president"
  },
  {
    name: "bull",
    uni: "E1CD",
    dec: "57805",
    tags: "cow"
  },
  {
    name: "cow",
    uni: "E1CE",
    dec: "57806",
    tags: "bull"
  },
  {
    name: "verified",
    uni: "E1E1",
    dec: "57825",
    tags: "shield, security"
  },
  {
    name: "verified_user",
    uni: "E1E2",
    dec: "57826",
    tags: "shield"
  },
  {
    name: "lock",
    uni: "E1E3",
    dec: "57827",
    tags: "padlock"
  },
  {
    name: "lock_open",
    uni: "E1E4",
    dec: "57828",
    tags: "padlock"
  },
  {
    name: "advertising",
    uni: "E1FA",
    dec: "57850",
    tags: "ads, publicity, campaign"
  },
  {
    name: "no_advertising",
    uni: "E1FB",
    dec: "57851",
    tags: "ads, publicity, campaign"
  },
  {
    name: "video",
    uni: "E1FC",
    dec: "57852",
    tags: "ads, publicity, campaign"
  },
  {
    name: "question_answer",
    uni: "E201",
    dec: "57857",
    tags: "faqs, help, info"
  },
  {
    name: "info",
    uni: "E202",
    dec: "57858",
    tags: "help"
  },
  {
    name: "help",
    uni: "E203",
    dec: "57859",
    tags: "info"
  },
  {
    name: "error",
    uni: "E204",
    dec: "57860",
    tags: "warning, alert"
  },
  {
    name: "visibility",
    uni: "E205",
    dec: "57861",
    tags: "eye, show"
  },
  {
    name: "visibility_off",
    uni: "E206",
    dec: "57862",
    tags: "eye, hide"
  },
  {
    name: "thumb_up",
    uni: "E207",
    dec: "57863",
    tags: "like"
  },
  {
    name: "thumb_down",
    uni: "E208",
    dec: "57864",
    tags: "like, unlike, dislike"
  },
  {
    name: "favorite_border",
    uni: "E209",
    dec: "57865",
    tags: "like, heart"
  },
  {
    name: "favorite",
    uni: "E20A",
    dec: "57866",
    tags: "like, heart"
  },
  {
    name: "favorite_dislike",
    uni: "E20B",
    dec: "57867",
    tags: "heart, like, unlike, dislike"
  },
  {
    name: "share",
    uni: "E20C",
    dec: "57868",
    tags: ""
  },
  {
    name: "bookmark",
    uni: "E20D",
    dec: "57869",
    tags: ""
  },
  {
    name: "star_border",
    uni: "E20E",
    dec: "57870",
    tags: "grade, rate"
  },
  {
    name: "star_half",
    uni: "E20F",
    dec: "57871",
    tags: "rate"
  },
  {
    name: "star",
    uni: "E210",
    dec: "57872",
    tags: "rate"
  },
  {
    name: "rate",
    uni: "E211",
    dec: "57873",
    tags: "review, start, comment, thumb"
  },
  {
    name: "ticket",
    uni: "E212",
    dec: "57874",
    tags: "voucher, pass"
  },
  {
    name: "game",
    uni: "E213",
    dec: "57875",
    tags: "play, console"
  },
  {
    name: "lotto",
    uni: "E214",
    dec: "57876",
    tags: "luck, bingo, casino, gaming, lottery"
  },
  {
    name: "cabala",
    uni: "E215",
    dec: "57877",
    tags: "eye, luck, dream, god"
  },
  {
    name: "clover",
    uni: "E216",
    dec: "57878",
    tags: "luck, dream, lotto, lottery"
  },
  {
    name: "sad_face",
    uni: "E22D",
    dec: "57901",
    tags: "emoji"
  },
  {
    name: "happy_face",
    uni: "E22E",
    dec: "57902",
    tags: "emoji"
  },
  {
    name: "dictation",
    uni: "E22F",
    dec: "57903",
    tags: "voice, sound, write, test"
  },
  {
    name: "oral",
    uni: "E230",
    dec: "57904",
    tags: "record, speech, mic, oral, text, voice, test"
  },
  {
    name: "event_available",
    uni: "E231",
    dec: "57905",
    tags: "calendar, event, date, appointment, schedule"
  },
  {
    name: "upcoming",
    uni: "E232",
    dec: "57906",
    tags: "calendar, event, date, appointment, schedule"
  },
  {
    name: "past",
    uni: "E233",
    dec: "57907",
    tags: "calendar, event, date, appointment, schedule"
  },
  {
    name: "event",
    uni: "E234",
    dec: "57908",
    tags: "calendar, date, appointment, schedule, today"
  },
  {
    name: "no_event",
    uni: "E235",
    dec: "57909",
    tags: "calendar, date, appointment, schedule"
  },
  {
    name: "month",
    uni: "E236",
    dec: "57910",
    tags: "calendar, event, date, appointment, schedule"
  },
  {
    name: "dashboard",
    uni: "E23A",
    dec: "57914",
    tags: "home, main"
  },
  {
    name: "campaign",
    uni: "E23B",
    dec: "57915",
    tags: "megaphone, bullhorn, mic, marketing, ads, publicity"
  },
  {
    name: "unpin",
    uni: "E243",
    dec: "57923",
    tags: "pin, locate"
  },
  {
    name: "push_pin",
    uni: "E244",
    dec: "57924",
    tags: "pin, locate"
  },
  {
    name: "search",
    uni: "E245",
    dec: "57925",
    tags: "magnifying, zoom"
  },
  {
    name: "search_page",
    uni: "E246",
    dec: "57926",
    tags: "magnifying, zoom, doc"
  },
  {
    name: "search_person",
    uni: "E247",
    dec: "57927",
    tags: "magnifying, zoom, account, user"
  },
  {
    name: "search_number",
    uni: "E248",
    dec: "57928",
    tags: "magnifying, zoom"
  },
  {
    name: "camera",
    uni: "E254",
    dec: "57940",
    tags: "photo"
  },
  {
    name: "no_image",
    uni: "E255",
    dec: "57941",
    tags: "collections, photos, gallery, media, image"
  },
  {
    name: "images",
    uni: "E256",
    dec: "57942",
    tags: "collections, photos, gallery, media, image"
  },
  {
    name: "remove",
    uni: "E257",
    dec: "57943",
    tags: "minus"
  },
  {
    name: "remove_circle",
    uni: "E258",
    dec: "57944",
    tags: "minus"
  },
  {
    name: "add",
    uni: "E259",
    dec: "57945",
    tags: "plus, sum"
  },
  {
    name: "add_circle",
    uni: "E25A",
    dec: "57946",
    tags: "plus, sum"
  },
  {
    name: "close",
    uni: "E25B",
    dec: "57947",
    tags: "cancel, clear, close"
  },
  {
    name: "cancel",
    uni: "E25C",
    dec: "57948",
    tags: "cancel, clear, close"
  },
  {
    name: "filter",
    uni: "E25D",
    dec: "57949",
    tags: "sort"
  },
  {
    name: "edit",
    uni: "E25E",
    dec: "57950",
    tags: "create, pen"
  },
  {
    name: "settings",
    uni: "E25F",
    dec: "57951",
    tags: "gear"
  },
  {
    name: "save",
    uni: "E260",
    dec: "57952",
    tags: "disk"
  },
  {
    name: "add_square",
    uni: "E262",
    dec: "57954",
    tags: "plus"
  },
  {
    name: "remove_square",
    uni: "E263",
    dec: "57955",
    tags: "minus"
  },
  {
    name: "more_less",
    uni: "E264",
    dec: "57956",
    tags: "approximately, roughly, plus, sum, minus"
  },
  {
    name: "total",
    uni: "E265",
    dec: "57957",
    tags: "amount, sum"
  },
  {
    name: "number",
    uni: "E266",
    dec: "57958",
    tags: "hashtag"
  },
  {
    name: "television",
    uni: "E26B",
    dec: "57963",
    tags: "tv, monitor"
  },
  {
    name: "store",
    uni: "E26C",
    dec: "57964",
    tags: "storefront, business, local"
  },
  {
    name: "drink",
    uni: "E26D",
    dec: "57965",
    tags: "amenity, bar, wine"
  },
  {
    name: "bulb_number",
    uni: "E279",
    dec: "57977",
    tags: "hint, light, idea, think"
  },
  {
    name: "bulb_on",
    uni: "E27A",
    dec: "57978",
    tags: "light, idea, hint, think"
  },
  {
    name: "bulb",
    uni: "E27B",
    dec: "57979",
    tags: "light, idea, think"
  },
  {
    name: "cashier",
    uni: "E27C",
    dec: "57980",
    tags: "pos, cash, register"
  },
  {
    name: "afternoon",
    uni: "E285",
    dec: "57989",
    tags: "sun, noon"
  },
  {
    name: "evening",
    uni: "E286",
    dec: "57990",
    tags: "evening, moom, night, dark, light"
  },
  {
    name: "full_square",
    uni: "E287",
    dec: "57991",
    tags: ""
  },
  {
    name: "full_dot",
    uni: "E288",
    dec: "57992",
    tags: "circle"
  },
  {
    name: "brightness_1",
    uni: "E289",
    dec: "57993",
    tags: ""
  },
  {
    name: "brightness_2",
    uni: "E28A",
    dec: "57994",
    tags: ""
  },
  {
    name: "brightness_3",
    uni: "E28B",
    dec: "57995",
    tags: ""
  },
  {
    name: "brightness_4",
    uni: "E28C",
    dec: "57996",
    tags: ""
  },
  {
    name: "brightness_5",
    uni: "E28D",
    dec: "57997",
    tags: ""
  },
  {
    name: "brightness_6",
    uni: "E28E",
    dec: "57998",
    tags: ""
  },
  {
    name: "brightness_7",
    uni: "E28F",
    dec: "57999",
    tags: "light, sun, dark"
  },
  {
    name: "facebook",
    uni: "E291",
    dec: "58001",
    tags: "social"
  },
  {
    name: "twitter",
    uni: "E292",
    dec: "58002",
    tags: "social"
  },
  {
    name: "youtube",
    uni: "E293",
    dec: "58003",
    tags: "social"
  },
  {
    name: "instagram",
    uni: "E294",
    dec: "58004",
    tags: "social"
  },
  {
    name: "linkedin",
    uni: "E295",
    dec: "58005",
    tags: "social"
  },
  {
    name: "github",
    uni: "E2A0",
    dec: "58016",
    tags: "logo"
  },
  {
    name: "gitlab",
    uni: "E2A1",
    dec: "58017",
    tags: "logo"
  },
  {
    name: "npm",
    uni: "E2A2",
    dec: "58018",
    tags: "logo"
  },
  {
    name: "apple_logo",
    uni: "E2A3",
    dec: "58019",
    tags: "logo"
  },
  {
    name: "facebook_logo",
    uni: "E2A4",
    dec: "58020",
    tags: "logo"
  },
  {
    name: "google_logo",
    uni: "E2A5",
    dec: "58021",
    tags: "logo"
  },
  {
    name: "whatsapp_logo",
    uni: "E2A6",
    dec: "58022",
    tags: "logo"
  },
  {
    name: "x_logo",
    uni: "E2A7",
    dec: "58023",
    tags: "logo, twitter"
  },
  {
    name: "logo",
    uni: "E2AF",
    dec: "58031",
    tags: "logo, create, art, font"
  }
];